import _ from 'underscore';
import {trim} from './strings';
import {EMPTY_FILTER} from './urls';

export const getAuctionCityState = (auctionData) => {
    let {
        city,
        state
    } = auctionData || {};
    
    city = trim(city);
    state = trim(state);
    
    return city && state ? `${city}, ${state}`
        : city ? city
        : state ? state
        : null;
};

export const getAuctioneerCityState = (auctionData) => {
    let {
        auctioneerCity: city,
        auctioneerState: state,
    } = auctionData || {};

    city = trim(city);
    state = trim(state);

    return city && state ? `${city}, ${state}`
        : city ? city
        : state ? state
        : null;
};

export const getFullAuctionAddress = (auctionData) => {
    const {
        city,
        state,
        street,
        zip
    } = auctionData || {};
    
    return _.compact([
        street,
        city,
        state && zip ? `${state} ${zip}` : (state || zip)
    ]).join(', ');
};

export const getAuctioneerDesignations = (auctionData) => {
    const {
        auctioneerDesignations,
    } = auctionData || {};

    return (
        auctioneerDesignations && auctioneerDesignations.length && auctioneerDesignations.join
            ? auctioneerDesignations.join(', ')
            : ''
    );
};

export const getFilterParamsFromMatch = (match, lockCategory) => {
    const {params} = match || {};
    let {page, category, region, date} = params || {};

    if (category === EMPTY_FILTER) {
        category = undefined;
    }
    if (region === EMPTY_FILTER) {
        region = undefined;
    }
    if (date === EMPTY_FILTER) {
        date = undefined;
    }

    if (lockCategory) {
        category = lockCategory;
    }

    return {page, category, region, date};
};
